import * as Sentry from "@sentry/react";
import { createContext, useContext, useEffect } from "react";
import { useAccount } from "@vojomo-core/shared";

export const useSentryProvider = () => {
  const { vojomoAccount } = useAccount();

  useEffect(() => {
    if (vojomoAccount) {
      Sentry.setUser({
        id: vojomoAccount["_id"],
        email: vojomoAccount.email,
        username: vojomoAccount.name,
      });
    } else {
      Sentry.setUser(null);
    }
  }, [vojomoAccount]);
};

export const SentryProvider = ({ children }: { children: React.ReactNode }) => {
  useSentryProvider();
  return <>{children}</>;
};

export type SentryProps = ReturnType<typeof useSentryProvider>;
export const SentryContext = createContext<SentryProps>(null);
export const useSentry = () => useContext(SentryContext);
